var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Circle } from "react-native-svg";
var SvgTimerDivider = function SvgTimerDivider(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 3 46"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFE9A8"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 1.5,
    cy: 19.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 1.5,
    cy: 26.5,
    r: 1.5
  }))));
};
export default SvgTimerDivider;